
import { join, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { int32ToString, createObj, equals } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Msg, StocktakingListTableRow, SelectedTab } from "./Types.js";
import { exists as exists_1, empty as empty_1, choose, append, map, head, tail, isEmpty, reduce, toArray, ofArray, length } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { InformationAlert, WarningAlert, SuccessAlert } from "../../Components/Alert.js";
import { InfiniteTable } from "../../Widgets/Table/InfiniteTable.js";
import Check from "../../../public/assets/icons/Check.svg";
import Delete_1 from "../../../public/assets/icons/Delete_1.svg";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { ColumnDefinition$1, CellContent } from "../../Widgets/Table/Types.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { StocktakingListId__get_unwrap, StocktakingId__get_unwrap, ConsumableId__get_unwrap, ToolId__get_unwrap } from "../../Shared/Shared.js";
import { unwrap, toArray as toArray_1, map as map_1, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { InventoryKind } from "../../Shared/InventoryStates.js";
import { append as append_1, exists, singleton, empty, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import Qr_Code from "../../../public/assets/icons/Qr_Code.svg";
import { TableControlElement$1, TableControl$1 } from "../../Widgets/Table/Table.js";
import { StocktakingListState, StocktakingState, StocktakingResultType } from "../../Shared/Stocktaking.js";
import { Helper_unitToTranslationKey } from "../../Shared/Consumable.js";
import { ConfirmStocktakingResultDialog } from "../Dialog/ConfirmStocktakingResultDialog.js";
import { CorrectionBookingDialog } from "../Dialog/CorrectionBookingDialog.js";
import { TabsMenu } from "../../Widgets/TabsMenu.js";
import { ChangelogTable } from "../../Widgets/Tables/ChangelogTable.js";
import { TextValue } from "../../Components/Text.js";
import { ConfirmationDialog } from "../../Components/Dialog.js";
import { TextButton } from "../../Components/Button.js";
import Arrow_Left_1 from "../../../public/assets/icons/Arrow_Left_1.svg";
import { append as append_2 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Array.js";
import Shipment_Time from "../../../public/assets/icons/Shipment_Time.svg";
import { canRecordStocktakingResults, canRecordAllStocktakingResults, usePermissions } from "../../UserPermissions.js";
import { DetailViewHeader } from "../../Widgets/DetailViewHeader.js";
import { CountingView } from "./CountingView.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { Skeleton } from "../../Components/Skeleton.js";

export function recordedByLabel(t, row) {
    let recordedBy;
    const matchValue = row.RecordedBy;
    if (matchValue == null) {
        return "";
    }
    else if ((recordedBy = matchValue, row.RecordedViaEmailLink)) {
        const recordedBy_1 = matchValue;
        return concat(recordedBy_1, " (", t("stocktaking.email_link.badge"), ...")");
    }
    else {
        const recordedBy_2 = matchValue;
        return recordedBy_2;
    }
}

export function StocktakingListTable(props) {
    let elems, TableRows, ColumnDefinitions, Options, matchValue_3, matchValue_4;
    const t = useTranslation()[0];
    if (equals(props.SelectedTab, new SelectedTab(0, [])) && (length(props.Rows) === 0)) {
        return reactElement("div", createObj(ofArray([["className", join(" ", ["max-w-[75rem]"])], (elems = [createElement(SuccessAlert, {
            Label: t("stocktaking.no_required_actions"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }
    else {
        return createElement(InfiniteTable, (TableRows = toArray(props.Rows), (ColumnDefinitions = [new ColumnDefinition$1("status_icon", "", t("stocktaking.status"), (dto) => {
            let matchValue, elems_3, elems_1, elems_2;
            return new CellContent(2, [(dto.RecordedBy != null) ? ((matchValue = dto.RecordedQuantity, (matchValue == null) ? reactElement("div", createObj(ofArray([["className", join(" ", ["text-primary", "h-5", "w-5"])], (elems_3 = [Check()], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))) : ((matchValue === dto.Quantity) ? reactElement("div", createObj(ofArray([["className", join(" ", ["text-primary", "h-5", "w-5"])], (elems_1 = [Check()], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))) : reactElement("div", createObj(ofArray([["className", join(" ", ["text-red", "h-5", "w-5"])], (elems_2 = [Delete_1()], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))))) : defaultOf()]);
        }, "none", "text"), new ColumnDefinition$1("image", "", t("general.image"), (dto_1) => (new CellContent(6, [dto_1.ImageUrl])), "none", "image"), new ColumnDefinition$1("inventoryNumber", "", t("general.inventory_number"), (dto_2) => (new CellContent(0, [dto_2.InventoryNumber])), "text", "text"), new ColumnDefinition$1("name", "", t("general.name"), (dto_3) => (new CellContent(3, [dto_3.Name, () => {
            const matchValue_1 = dto_3.StocktakingResultType;
            switch (matchValue_1.tag) {
                case 0: {
                    RouterModule_nav(ofArray(["tools", ToolId__get_unwrap(matchValue_1.fields[0])]), 1, 1);
                    break;
                }
                case 1: {
                    RouterModule_nav(ofArray(["toolswithquantity", ToolId__get_unwrap(matchValue_1.fields[0])]), 1, 1);
                    break;
                }
                default:
                    RouterModule_nav(ofArray(["consumables", ConsumableId__get_unwrap(matchValue_1.fields[0])]), 1, 1);
            }
        }])), "text", "button"), new ColumnDefinition$1("manufacturer", "", t("tool.manufacturer"), (dto_4) => (new CellContent(0, [dto_4.Manufacturer])), "text", "text"), new ColumnDefinition$1("model", "", t("tool.model"), (dto_5) => (new CellContent(0, [dto_5.Model])), "text", "text"), new ColumnDefinition$1("serialNumber", "", t("general.serial_number"), (dto_6) => (new CellContent(0, [dto_6.SerialNumber])), "text", "text"), new ColumnDefinition$1("qrCodeIds", "", t("general.qr_code"), (dto_7) => (new CellContent(0, [(length(dto_7.QRCodeIds) > 0) ? reduce((output, code) => concat(code, ", ", ...output), dto_7.QRCodeIds) : ""])), "text", "text"), new ColumnDefinition$1("quantity", "", t("general.quantity"), (dto_8) => (new CellContent(0, [dto_8.Quantity])), "text", "text"), new ColumnDefinition$1("unit", "", t("general.unit"), (dto_9) => (new CellContent(0, [dto_9.Unit])), "select", "text"), new ColumnDefinition$1("storageSpace", "", t("tool.storage_space"), (dto_10) => (new CellContent(0, [dto_10.StorageSpace])), "select", "text"), new ColumnDefinition$1("recordedBy", "", t("stocktaking.recorded_by"), (dto_11) => (new CellContent(0, [recordedByLabel(t, dto_11)])), "select", "text"), new ColumnDefinition$1("recordTimestamp", "", t("stocktaking.record_timestamp"), (dto_12) => (new CellContent(9, [dto_12.RecordTimestamp])), "none", "dateTime"), new ColumnDefinition$1("recordedQuantity", "", t("stocktaking.recorded_quantity"), (dto_13) => (new CellContent(0, [defaultArg(dto_13.RecordedQuantity, "")])), "text", "text"), new ColumnDefinition$1("correctedBy", "", t("stocktaking.corrected_by"), (dto_14) => (new CellContent(0, [defaultArg(dto_14.CorrectedBy, "")])), "select", "text"), new ColumnDefinition$1("correctionTimestamp", "", t("stocktaking.correction_timestamp"), (dto_15) => (new CellContent(9, [dto_15.CorrectionTimestamp])), "none", "dateTime"), new ColumnDefinition$1("correctionQuantity", "", t("stocktaking.correction_quantity"), (dto_16) => (new CellContent(0, [defaultArg(dto_16.CorrectionQuantity, "")])), "text", "text"), new ColumnDefinition$1("isToolWithQuantity", t("general.master_data"), t("general.tool_type"), (dto_17) => {
            let matchValue_2;
            return new CellContent(5, [(matchValue_2 = dto_17.StocktakingResultType, (matchValue_2.tag === 1) ? (new InventoryKind(2, [])) : ((matchValue_2.tag === 2) ? (new InventoryKind(3, [])) : (new InventoryKind(0, []))))]);
        }, "select", "text")], (Options = {
            BorderStyle: "row",
            CSVDownload: true,
            ConfigurableColumns: true,
            CustomTableFilters: false,
            DefaultSortColumn: ["name", "asc"],
            Fullscreen: false,
            GlobalSearch: true,
            RowSelection: (matchValue_3 = props.Stocktaking.State, (matchValue_3.tag === 1) ? "disabled" : ((matchValue_3.tag === 4) ? "disabled" : ((matchValue_3.tag === 2) ? ((matchValue_4 = props.StocktakingList.State, (matchValue_4.tag === 0) ? "disabled" : ((matchValue_4.tag === 1) ? "singleRow" : "disabled"))) : ((matchValue_3.tag === 3) ? "multiRow" : "disabled")))),
            SaveTableConfiguration: true,
            WithQueryParameters: false,
        }, {
            ColumnDefinitions: ColumnDefinitions,
            Controls: toList(delay(() => {
                const matchValue_5 = props.Stocktaking.State;
                let matchResult;
                switch (matchValue_5.tag) {
                    case 2: {
                        matchResult = 1;
                        break;
                    }
                    case 3: {
                        if (!props.Stocktaking.CanCorrect) {
                            matchResult = 2;
                        }
                        else {
                            matchResult = 3;
                        }
                        break;
                    }
                    default:
                        matchResult = 0;
                }
                switch (matchResult) {
                    case 0: {
                        return empty();
                    }
                    case 1: {
                        const matchValue_6 = props.StocktakingList.State;
                        switch (matchValue_6.tag) {
                            case 1:
                                return singleton(new TableControlElement$1(0, [new TableControl$1(t("stocktaking.add_result"), Qr_Code(), (value_11) => {
                                    let matchResult_1, selectedElement;
                                    if (!isEmpty(value_11)) {
                                        if (isEmpty(tail(value_11))) {
                                            matchResult_1 = 0;
                                            selectedElement = head(value_11);
                                        }
                                        else {
                                            matchResult_1 = 1;
                                        }
                                    }
                                    else {
                                        matchResult_1 = 1;
                                    }
                                    switch (matchResult_1) {
                                        case 0: {
                                            props.SetIsConfirmStocktakingResultDialogOpen(selectedElement.StocktakingResultType);
                                            break;
                                        }
                                        case 1: {
                                            break;
                                        }
                                    }
                                }, true, false, "stocktaking-add-result")]));
                            default: {
                                return empty();
                            }
                        }
                    }
                    case 2: {
                        return empty();
                    }
                    default:
                        return singleton(new TableControlElement$1(0, [new TableControl$1(t("stocktaking.do_correction_booking"), Qr_Code(), (values) => {
                            props.SetIsCorrectionBookingDialogOpen(map((value_12) => value_12.StocktakingResultType, values));
                        }, true, false, "stocktaking-correction-booking")]));
                }
            })),
            Options: Options,
            TableKey: "stocktaking-list",
            TableRows: TableRows,
        }))));
    }
}

export function StocktakingListOverviewSection(props) {
    let elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(undefined);
    const setIsConfirmStocktakingResultDialogOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(undefined);
    const setIsCorrectionBookingDialogOpen = patternInput_2[1];
    let patternInput_3;
    let initial_2;
    const matchValue = props.Stocktaking.State;
    switch (matchValue.tag) {
        case 2:
        case 3:
        case 4: {
            initial_2 = (new SelectedTab(0, []));
            break;
        }
        default:
            initial_2 = (new SelectedTab(1, []));
    }
    patternInput_3 = reactApi.useState(initial_2);
    const setSelectedTab = patternInput_3[1];
    const selectedTab = patternInput_3[0];
    const overviewRows = append(choose((stocktakingListTool) => (new StocktakingListTableRow(stocktakingListTool.ImageUrl, stocktakingListTool.InventoryNumber, "", stocktakingListTool.DisplayName, stocktakingListTool.Manufacturer, stocktakingListTool.Model, stocktakingListTool.SerialNumber, stocktakingListTool.QRCodeIds, stocktakingListTool.StorageSpace, "1", map_1((_arg) => _arg.RecordedBy, stocktakingListTool.Result), exists((_arg_1) => _arg_1.RecordedViaEmailLink, toArray_1(stocktakingListTool.Result)), map_1((_arg_2) => _arg_2.Timestamp, stocktakingListTool.Result), map_1((result) => {
        if (result.Existing) {
            return "1";
        }
        else {
            return "0";
        }
    }, stocktakingListTool.Result), map_1((_arg_3) => _arg_3.CorrectedBy, stocktakingListTool.Correction), map_1((_arg_4) => _arg_4.Timestamp, stocktakingListTool.Correction), undefined, new StocktakingResultType(0, [stocktakingListTool.ToolId]))), props.StocktakingList.Tools), append(choose((stocktakingListToolWithQuantity) => (new StocktakingListTableRow(stocktakingListToolWithQuantity.ImageUrl, stocktakingListToolWithQuantity.InventoryNumber, t(Helper_unitToTranslationKey("piece")), stocktakingListToolWithQuantity.DisplayName, stocktakingListToolWithQuantity.Manufacturer, stocktakingListToolWithQuantity.Model, "", stocktakingListToolWithQuantity.QRCodeIds, stocktakingListToolWithQuantity.StorageSpace, int32ToString(stocktakingListToolWithQuantity.Quantity), map_1((_arg_6) => _arg_6.RecordedBy, stocktakingListToolWithQuantity.Result), exists((_arg_7) => _arg_7.RecordedViaEmailLink, toArray_1(stocktakingListToolWithQuantity.Result)), map_1((_arg_8) => _arg_8.Timestamp, stocktakingListToolWithQuantity.Result), map_1((arg) => int32ToString(arg.Quantity), stocktakingListToolWithQuantity.Result), map_1((_arg_10) => _arg_10.CorrectedBy, stocktakingListToolWithQuantity.Correction), map_1((_arg_11) => _arg_11.Timestamp, stocktakingListToolWithQuantity.Correction), map_1((arg_1) => int32ToString(arg_1.Quantity), stocktakingListToolWithQuantity.Correction), new StocktakingResultType(1, [stocktakingListToolWithQuantity.ToolId]))), props.StocktakingList.ToolsWithQuantity), choose((stocktakingListConsumable) => (new StocktakingListTableRow(stocktakingListConsumable.ImageUrl, stocktakingListConsumable.InventoryNumber, t(Helper_unitToTranslationKey(stocktakingListConsumable.Unit)), stocktakingListConsumable.ConsumableName, "", "", "", stocktakingListConsumable.QRCodeIds, stocktakingListConsumable.StorageSpace, stocktakingListConsumable.Quantity.toString(), map_1((_arg_14) => _arg_14.RecordedBy, stocktakingListConsumable.Result), exists((_arg_15) => _arg_15.RecordedViaEmailLink, toArray_1(stocktakingListConsumable.Result)), map_1((_arg_16) => _arg_16.Timestamp, stocktakingListConsumable.Result), map_1((arg_2) => arg_2.Quantity.toString(), stocktakingListConsumable.Result), map_1((_arg_18) => _arg_18.CorrectedBy, stocktakingListConsumable.Correction), map_1((_arg_19) => _arg_19.Timestamp, stocktakingListConsumable.Correction), map_1((arg_3) => arg_3.Quantity.toString(), stocktakingListConsumable.Correction), new StocktakingResultType(2, [stocktakingListConsumable.ConsumableId]))), props.StocktakingList.Consumables)));
    const requiredActionsRows = append(choose((stocktakingListTool_1) => {
        let result_1;
        const matchValue_1 = stocktakingListTool_1.Result;
        const matchValue_2 = stocktakingListTool_1.Correction;
        let matchResult, result_2;
        if (matchValue_1 != null) {
            if (matchValue_2 != null) {
                matchResult = 2;
            }
            else if ((result_1 = matchValue_1, equals(props.Stocktaking.State, new StocktakingState(3, [])) && !result_1.Existing)) {
                matchResult = 1;
                result_2 = matchValue_1;
            }
            else {
                matchResult = 2;
            }
        }
        else if (matchValue_2 != null) {
            matchResult = 2;
        }
        else {
            matchResult = 0;
        }
        switch (matchResult) {
            case 0:
                return new StocktakingListTableRow(stocktakingListTool_1.ImageUrl, stocktakingListTool_1.InventoryNumber, "", stocktakingListTool_1.DisplayName, stocktakingListTool_1.Manufacturer, stocktakingListTool_1.Model, stocktakingListTool_1.SerialNumber, stocktakingListTool_1.QRCodeIds, stocktakingListTool_1.StorageSpace, "", undefined, false, undefined, undefined, undefined, undefined, undefined, new StocktakingResultType(0, [stocktakingListTool_1.ToolId]));
            case 1:
                return new StocktakingListTableRow(stocktakingListTool_1.ImageUrl, stocktakingListTool_1.InventoryNumber, "", stocktakingListTool_1.DisplayName, stocktakingListTool_1.Manufacturer, stocktakingListTool_1.Model, "", stocktakingListTool_1.QRCodeIds, stocktakingListTool_1.StorageSpace, "1", result_2.RecordedBy, result_2.RecordedViaEmailLink, result_2.Timestamp, "0", undefined, undefined, undefined, new StocktakingResultType(0, [stocktakingListTool_1.ToolId]));
            default:
                return undefined;
        }
    }, props.StocktakingList.Tools), append(choose((stocktakingListToolWithQuantity_1) => {
        let result_3;
        const matchValue_4 = stocktakingListToolWithQuantity_1.Result;
        const matchValue_5 = stocktakingListToolWithQuantity_1.Correction;
        let matchResult_1, result_4;
        if (matchValue_4 != null) {
            if (matchValue_5 != null) {
                matchResult_1 = 2;
            }
            else if ((result_3 = matchValue_4, equals(props.Stocktaking.State, new StocktakingState(3, [])) && (result_3.Quantity !== stocktakingListToolWithQuantity_1.Quantity))) {
                matchResult_1 = 1;
                result_4 = matchValue_4;
            }
            else {
                matchResult_1 = 2;
            }
        }
        else if (matchValue_5 != null) {
            matchResult_1 = 2;
        }
        else {
            matchResult_1 = 0;
        }
        switch (matchResult_1) {
            case 0:
                return new StocktakingListTableRow(stocktakingListToolWithQuantity_1.ImageUrl, stocktakingListToolWithQuantity_1.InventoryNumber, t(Helper_unitToTranslationKey("piece")), stocktakingListToolWithQuantity_1.DisplayName, stocktakingListToolWithQuantity_1.Manufacturer, stocktakingListToolWithQuantity_1.Model, "", stocktakingListToolWithQuantity_1.QRCodeIds, stocktakingListToolWithQuantity_1.StorageSpace, int32ToString(stocktakingListToolWithQuantity_1.Quantity), undefined, false, undefined, undefined, undefined, undefined, undefined, new StocktakingResultType(1, [stocktakingListToolWithQuantity_1.ToolId]));
            case 1:
                return new StocktakingListTableRow(stocktakingListToolWithQuantity_1.ImageUrl, stocktakingListToolWithQuantity_1.InventoryNumber, t(Helper_unitToTranslationKey("piece")), stocktakingListToolWithQuantity_1.DisplayName, stocktakingListToolWithQuantity_1.Manufacturer, stocktakingListToolWithQuantity_1.Model, "", stocktakingListToolWithQuantity_1.QRCodeIds, stocktakingListToolWithQuantity_1.StorageSpace, int32ToString(stocktakingListToolWithQuantity_1.Quantity), map_1((_arg_23) => _arg_23.RecordedBy, stocktakingListToolWithQuantity_1.Result), exists((_arg_24) => _arg_24.RecordedViaEmailLink, toArray_1(stocktakingListToolWithQuantity_1.Result)), map_1((_arg_25) => _arg_25.Timestamp, stocktakingListToolWithQuantity_1.Result), map_1((arg_4) => int32ToString(arg_4.Quantity), stocktakingListToolWithQuantity_1.Result), map_1((_arg_27) => _arg_27.CorrectedBy, stocktakingListToolWithQuantity_1.Correction), map_1((_arg_28) => _arg_28.Timestamp, stocktakingListToolWithQuantity_1.Correction), map_1((arg_5) => int32ToString(arg_5.Quantity), stocktakingListToolWithQuantity_1.Correction), new StocktakingResultType(1, [stocktakingListToolWithQuantity_1.ToolId]));
            default:
                return undefined;
        }
    }, props.StocktakingList.ToolsWithQuantity), choose((stocktakingListConsumable_1) => {
        let result_5;
        const matchValue_7 = stocktakingListConsumable_1.Result;
        const matchValue_8 = stocktakingListConsumable_1.Correction;
        let matchResult_2, result_6;
        if (matchValue_7 != null) {
            if (matchValue_8 != null) {
                matchResult_2 = 2;
            }
            else if ((result_5 = matchValue_7, equals(props.Stocktaking.State, new StocktakingState(3, [])) && (result_5.Quantity !== stocktakingListConsumable_1.Quantity))) {
                matchResult_2 = 1;
                result_6 = matchValue_7;
            }
            else {
                matchResult_2 = 2;
            }
        }
        else if (matchValue_8 != null) {
            matchResult_2 = 2;
        }
        else {
            matchResult_2 = 0;
        }
        switch (matchResult_2) {
            case 0:
                return new StocktakingListTableRow(stocktakingListConsumable_1.ImageUrl, stocktakingListConsumable_1.InventoryNumber, t(Helper_unitToTranslationKey(stocktakingListConsumable_1.Unit)), stocktakingListConsumable_1.ConsumableName, "", "", "", stocktakingListConsumable_1.QRCodeIds, stocktakingListConsumable_1.StorageSpace, stocktakingListConsumable_1.Quantity.toString(), undefined, false, undefined, undefined, undefined, undefined, undefined, new StocktakingResultType(2, [stocktakingListConsumable_1.ConsumableId]));
            case 1:
                return new StocktakingListTableRow(stocktakingListConsumable_1.ImageUrl, stocktakingListConsumable_1.InventoryNumber, t(Helper_unitToTranslationKey(stocktakingListConsumable_1.Unit)), stocktakingListConsumable_1.ConsumableName, "", "", "", stocktakingListConsumable_1.QRCodeIds, stocktakingListConsumable_1.StorageSpace, stocktakingListConsumable_1.Quantity.toString(), map_1((_arg_32) => _arg_32.RecordedBy, stocktakingListConsumable_1.Result), exists((_arg_33) => _arg_33.RecordedViaEmailLink, toArray_1(stocktakingListConsumable_1.Result)), map_1((_arg_34) => _arg_34.Timestamp, stocktakingListConsumable_1.Result), map_1((arg_6) => arg_6.Quantity.toString(), stocktakingListConsumable_1.Result), map_1((_arg_36) => _arg_36.CorrectedBy, stocktakingListConsumable_1.Correction), map_1((_arg_37) => _arg_37.Timestamp, stocktakingListConsumable_1.Correction), map_1((arg_7) => arg_7.Quantity.toString(), stocktakingListConsumable_1.Correction), new StocktakingResultType(2, [stocktakingListConsumable_1.ConsumableId]));
            default:
                return undefined;
        }
    }, props.StocktakingList.Consumables)));
    return reactElement("div", createObj(ofArray([["className", join(" ", ["row-start-2", "col-span-2"])], (elems_1 = toList(delay(() => append_1(singleton(createElement(ConfirmStocktakingResultDialog, {
        OnClose: () => {
            setIsConfirmStocktakingResultDialogOpen(undefined);
            props.Dispatch(new Msg(0, []));
            props.Dispatch(new Msg(1, []));
        },
        Stocktaking: props.Stocktaking,
        StocktakingList: props.StocktakingList,
        StocktakingResultType: unwrap(patternInput_1[0]),
    })), delay(() => append_1(singleton(createElement(CorrectionBookingDialog, {
        OnClose: () => {
            setIsCorrectionBookingDialogOpen(undefined);
            props.Dispatch(new Msg(0, []));
            props.Dispatch(new Msg(1, []));
        },
        Stocktaking: props.Stocktaking,
        StocktakingListId: props.StocktakingList.Id,
        StocktakingResultType: unwrap(patternInput_2[0]),
        UserId: props.UserId,
        UserName: props.UserName,
    })), delay(() => {
        let elems;
        const requiredActionsTranslation = t("stocktaking.required_actions");
        const overviewTranslation = t("general.overview");
        return append_1(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems = [createElement(TabsMenu, {
            Tabs: toList(delay(() => {
                let matchValue_10, Label;
                return append_1((matchValue_10 = props.Stocktaking.State, (matchValue_10.tag === 1) ? (empty()) : ((matchValue_10.tag === 2) ? singleton((Label = (`${requiredActionsTranslation} (${length(requiredActionsRows)})`), {
                    IsSelected: equals(selectedTab, new SelectedTab(0, [])),
                    Label: Label,
                    OnClick: () => {
                        setSelectedTab(new SelectedTab(0, []));
                    },
                    TestId: "stocktaking-tab-required-actions",
                })) : ((matchValue_10.tag === 3) ? singleton((Label = (`${requiredActionsTranslation} (${length(requiredActionsRows)})`), {
                    IsSelected: equals(selectedTab, new SelectedTab(0, [])),
                    Label: Label,
                    OnClick: () => {
                        setSelectedTab(new SelectedTab(0, []));
                    },
                    TestId: "stocktaking-tab-required-actions",
                })) : ((matchValue_10.tag === 4) ? singleton((Label = (`${requiredActionsTranslation} (${length(requiredActionsRows)})`), {
                    IsSelected: equals(selectedTab, new SelectedTab(0, [])),
                    Label: Label,
                    OnClick: () => {
                        setSelectedTab(new SelectedTab(0, []));
                    },
                    TestId: "stocktaking-tab-required-actions",
                })) : (empty()))))), delay(() => {
                    let Label_1;
                    return append_1(singleton((Label_1 = (`${overviewTranslation} (${length(overviewRows)})`), {
                        IsSelected: equals(selectedTab, new SelectedTab(1, [])),
                        Label: Label_1,
                        OnClick: () => {
                            setSelectedTab(new SelectedTab(1, []));
                        },
                        TestId: "stocktaking-tab-overview",
                    })), delay(() => {
                        let Label_2;
                        return singleton((Label_2 = t("general.history"), {
                            IsSelected: equals(selectedTab, new SelectedTab(2, [])),
                            Label: Label_2,
                            OnClick: () => {
                                setSelectedTab(new SelectedTab(2, []));
                            },
                            TestId: "stocktaking-tab-history",
                        }));
                    }));
                }));
            })),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            const matchValue_11 = selectedTab;
            switch (matchValue_11.tag) {
                case 2:
                    return singleton(createElement(ChangelogTable, {
                        Changelogs: props.Changelogs,
                    }));
                default:
                    return singleton(createElement(StocktakingListTable, {
                        Rows: (selectedTab.tag === 1) ? overviewRows : ((selectedTab.tag === 2) ? empty_1() : requiredActionsRows),
                        SelectedTab: selectedTab,
                        SetIsConfirmStocktakingResultDialogOpen: setIsConfirmStocktakingResultDialogOpen,
                        SetIsCorrectionBookingDialogOpen: setIsCorrectionBookingDialogOpen,
                        Stocktaking: props.Stocktaking,
                        StocktakingList: props.StocktakingList,
                    }));
            }
        }));
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function OverviewInformationSection(props) {
    let elems_1, elems;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems = [createElement(TextValue, {
        FontWeight: "bold",
        TestId: "stocktaking-list-scope-name",
        Text: t("stocktaking.scope"),
    }), createElement(TextValue, {
        FontWeight: "normal",
        TestId: "stocktaking-list-scope-name-value",
        Text: props.StocktakingList.DisplayName,
    }), createElement(TextValue, {
        FontWeight: "bold",
        TestId: "stocktaking-list-affected-elements",
        Text: t("stocktaking.affected_elements"),
    }), createElement(TextValue, {
        FontWeight: "normal",
        TestId: "stocktaking-list-affected-elements-value",
        Text: int32ToString((length(props.StocktakingList.Tools) + length(props.StocktakingList.ToolsWithQuantity)) + length(props.StocktakingList.Consumables)),
    }), createElement(TextValue, {
        FontWeight: "bold",
        TestId: "stocktaking-list-helper",
        Text: t("stocktaking.stocktaking_helper"),
    }), createElement(TextValue, {
        FontWeight: "normal",
        TestId: "stocktaking-list-helper-value",
        Text: isEmpty(props.StocktakingList.Helper) ? "" : reduce((e1, e2) => concat(e1, ",", ...e2), map((helper) => helper.Name, props.StocktakingList.Helper)),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function DetailsActions(props) {
    let elems_1, Title, Title_1, elems;
    const t = useTranslation()[0];
    const listRoute = ["stocktaking", StocktakingId__get_unwrap(props.Stocktaking.Id), "lists", StocktakingListId__get_unwrap(props.StocktakingList.Id)];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-between"])], (elems_1 = [createElement(ConfirmationDialog, (Title = t("stocktaking.dialog.list.state_to_start_title"), {
        Description: t("stocktaking.dialog.list.state_to_start_description"),
        FormState: props.FormState,
        IsOpen: props.DialogOpenState.IsConfirmationStateStartDialogOpen,
        OnClose: () => {
            props.Dispatch(new Msg(5, [false]));
        },
        OnConfirm: () => {
            props.Dispatch(new Msg(3, []));
        },
        Title: Title,
    })), createElement(ConfirmationDialog, (Title_1 = t("stocktaking.dialog.list.state_to_done_title"), {
        Description: t("stocktaking.dialog.list.state_to_done_description"),
        FormState: props.FormState,
        IsOpen: props.DialogOpenState.IsConfirmationStateDoneDialogOpen,
        OnClose: () => {
            props.Dispatch(new Msg(6, [false]));
        },
        OnConfirm: () => {
            props.Dispatch(new Msg(4, []));
        },
        Title: Title_1,
    })), reactElement("div", {}), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-7"])], (elems = toList(delay(() => {
        let Label, Label_1;
        const matchValue = props.Stocktaking.State;
        switch (matchValue.tag) {
            case 2:
                return append_1(props.CountingMode ? (props.Stocktaking.CanUpdate ? singleton(createElement(TextButton, (Label = t("stocktaking.counting.exit"), {
                    ComponentState: "enabled",
                    Icon: Arrow_Left_1(),
                    Label: Label,
                    OnClick: () => {
                        RouterModule_nav(ofArray(listRoute), 1, 1);
                    },
                    TestId: "stocktaking-list-exit-counting-mode-button",
                    Variant: "default",
                }))) : empty()) : ((props.CanCount && equals(props.StocktakingList.State, new StocktakingListState(1, []))) ? singleton(createElement(TextButton, (Label_1 = t("stocktaking.counting.title"), {
                    ComponentState: "enabled",
                    Icon: Qr_Code(),
                    Label: Label_1,
                    OnClick: () => {
                        RouterModule_nav(ofArray(append_2(listRoute, ["count"])), 1, 1);
                    },
                    TestId: "stocktaking-list-counting-mode-button",
                    Variant: "default",
                }))) : empty()), delay(() => {
                    let Label_2, Label_3;
                    const matchValue_1 = props.StocktakingList.State;
                    switch (matchValue_1.tag) {
                        case 1:
                            return singleton(createElement(TextButton, (Label_2 = t("stocktaking.list_state.to_done"), {
                                ComponentState: "enabled",
                                Icon: Shipment_Time(),
                                Label: Label_2,
                                OnClick: () => {
                                    props.Dispatch(new Msg(6, [true]));
                                },
                                TestId: "stocktaking-list-done-state-button",
                                Variant: "default",
                            })));
                        case 0:
                            return singleton(createElement(TextButton, (Label_3 = t("stocktaking.list_state.to_start"), {
                                ComponentState: "enabled",
                                Icon: Shipment_Time(),
                                Label: Label_3,
                                OnClick: () => {
                                    props.Dispatch(new Msg(5, [true]));
                                },
                                TestId: "stocktaking-list-start-state-button",
                                Variant: "default",
                            })));
                        default: {
                            return empty();
                        }
                    }
                }));
            default: {
                return empty();
            }
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function OverviewSection(props) {
    let elems_2, elems_1, elems;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "grow"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "rounded", "px-12", "py-9"])], (elems_1 = [DetailsActions({
        CanCount: props.CanCount,
        CountingMode: props.CountingMode,
        DialogOpenState: props.DialogOpenState,
        Dispatch: props.Dispatch,
        FormState: props.FormState,
        Stocktaking: props.Stocktaking,
        StocktakingList: props.StocktakingList,
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "mt-6"])], (elems = [createElement(OverviewInformationSection, {
        StocktakingList: props.StocktakingList,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function StocktakingListDetailView(props) {
    let elems_5;
    const patternInput = useTranslation();
    const permissions = usePermissions();
    const isHelper = exists_1((helper) => (helper.Id === props.UserId), props.StocktakingList.Helper);
    const canCount = canRecordAllStocktakingResults(permissions) ? true : (canRecordStocktakingResults(permissions) && isHelper);
    const isCounting = (props.CountingMode && canCount) && equals(props.Stocktaking.State, new StocktakingState(2, []));
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full", "grid", "grid-cols-[max(75rem)_1fr]", "grid-rows-[auto_minmax(0,1fr)]", "gap-y-8"])], (elems_5 = toList(delay(() => {
        let elems_2, elems, elems_1;
        return append_1(singleton(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = toList(delay(() => (props.Stocktaking.CanUpdate ? singleton(createElement(DetailViewHeader, {
            Badges: empty_1(),
            CustomBackButtonLabel: patternInput[0]("general.back"),
            OnBack: () => {
                RouterModule_nav(ofArray(["stocktaking", StocktakingId__get_unwrap(props.Stocktaking.Id)]), 1, 1);
            },
            Title: props.StocktakingList.DisplayName,
        })) : singleton(reactElement("div", {
            "data-test-id": "stocktaking-list-helper-header",
            className: join(" ", ["font-bold", "text-4xl", "text-black"]),
            children: props.StocktakingList.DisplayName,
        }))))), ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_1 = [createElement(OverviewSection, {
            CanCount: canCount,
            CountingMode: isCounting,
            DialogOpenState: props.DialogOpenState,
            Dispatch: props.Dispatch,
            FormState: props.FormState,
            Stocktaking: props.Stocktaking,
            StocktakingList: props.StocktakingList,
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
            let elems_3, elems_4;
            if (isCounting) {
                const matchValue = props.StocktakingList.State;
                return (matchValue.tag === 0) ? singleton(reactElement("div", createObj(ofArray([["data-test-id", "stocktaking-counting-list-not-started"], ["className", join(" ", ["row-start-2", "col-span-2", "max-w-[75rem]"])], (elems_3 = [createElement(WarningAlert, {
                    Label: "stocktaking.counting.list_not_started",
                })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))) : ((matchValue.tag === 2) ? singleton(reactElement("div", createObj(ofArray([["data-test-id", "stocktaking-counting-list-done"], ["className", join(" ", ["row-start-2", "col-span-2", "max-w-[75rem]"])], (elems_4 = [createElement(InformationAlert, {
                    Label: "stocktaking.counting.list_done",
                })], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))) : singleton(createElement(CountingView, {
                    Counting: props.Counting,
                    Dispatch: (arg) => {
                        props.Dispatch(new Msg(10, [arg]));
                    },
                    StocktakingList: props.StocktakingList,
                })));
            }
            else {
                return singleton(createElement(StocktakingListOverviewSection, {
                    Changelogs: props.Changelogs,
                    Dispatch: props.Dispatch,
                    Stocktaking: props.Stocktaking,
                    StocktakingList: props.StocktakingList,
                    UserId: props.UserId,
                    UserName: props.UserName,
                }));
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

export function DetailView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram((tupledArg) => init_1(tupledArg[0], tupledArg[1]), update_1, (_arg, _arg_1) => {
    }), [props.StocktakingId, props.StocktakingListId], undefined);
    const state_1 = patternInput[0];
    const matchValue = state_1.Stocktaking;
    const matchValue_1 = state_1.StocktakingList;
    const matchValue_2 = state_1.Changelogs;
    let matchResult, changelogs, stocktaking, stocktakingList;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        changelogs = matchValue_2.fields[0];
        stocktaking = matchValue.fields[0];
        stocktakingList = matchValue_1.fields[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(StocktakingListDetailView, {
                Changelogs: changelogs,
                Counting: state_1.Counting,
                CountingMode: props.CountingMode,
                DialogOpenState: state_1.DialogOpenState,
                Dispatch: patternInput[1],
                FormState: state_1.FormState,
                Stocktaking: stocktaking,
                StocktakingList: stocktakingList,
                UserId: props.UserId,
                UserName: props.UserName,
            });
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

